import React, { isValidElement } from 'react';
import { IconRenderer } from "./IconRenderer.js";
import { Icon } from "../../components/icon/Icon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function LegacyIconRenderer({
  icon,
  className,
  size = 24,
  title
}) {
  if (!icon) {
    return null;
  }
  const isOldPlatformIcon = typeof icon === 'string';
  const isFontAwesomeIcon = typeof icon === 'object' && Array.isArray(icon);
  const isIconLookup = typeof icon === 'object' && Object.prototype.hasOwnProperty.call(icon, 'prefix') && Object.prototype.hasOwnProperty.call(icon, 'iconName') && ! /*#__PURE__*/isValidElement(icon);
  if (isOldPlatformIcon || isFontAwesomeIcon || isIconLookup) {
    const calculatedSize = size === 'DEFAULT' ? 20 : size === 'SMALL' ? 16 : size;
    return /*#__PURE__*/_jsx(Icon, {
      icon: icon,
      size: calculatedSize,
      className: className
    });
  }
  return /*#__PURE__*/_jsx(IconRenderer, {
    icon: icon,
    className: className,
    size: size,
    title: title
  });
}